import React from "react";
import { Input } from "antd";
import type { SearchProps } from "antd/es/input";
import { filterUpdateEvent } from "@/utils/analytics/googleAnalytics";

function CustomSearchBox(props: {
    handleSubmit: (value: string) => void;
    value?: string;
    defaultValue?: string;
    onValueChange?: (condition: string) => void;
    loading?: boolean;
    size?: SearchProps["size"];
    className?: string;
    placeholder?: string;
}) {
    const { value, onValueChange, handleSubmit, loading, size, defaultValue, className, placeholder } = props;

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (onValueChange) onValueChange(event.target.value);
    };

    const handleEnter = (enterValue: string) => {
        filterUpdateEvent("condition", enterValue, "search");
        handleSubmit(enterValue);
    };

    return (
        <Input.Search
            id="condition-search-box"
            className={className}
            size={size}
            defaultValue={defaultValue}
            value={value}
            loading={loading}
            onChange={handleInputChange}
            enterButton
            onSearch={handleEnter}
            placeholder={placeholder || "Search for any condition"}
        />
    );
}

CustomSearchBox.defaultProps = {
    value: undefined,
    defaultValue: undefined,
    onValueChange: undefined,
    loading: false,
    size: undefined,
    className: undefined,
};

export default CustomSearchBox;
